import React, { createContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { clearAuthStorage } from "../authStorage";

export const InactivityContext = createContext();

const INACTIVITY_LIMIT = 15 * 60 * 1000; // 20 minutes in ms
const EXCLUDED_PATHS = ["/", "/login", "/signup", "/sat-test"];

export const InactivityProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const timerRef = useRef();

  // Your logout logic here
  const logout = () => {
    clearAuthStorage();
    alert("You have been logged out due to inactivity.");
    window.location.reload();
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    if (EXCLUDED_PATHS.includes(location.pathname)) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }
    // List of events to consider as activity
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer(); // Start timer on mount or path change

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <InactivityContext.Provider value={{ resetTimer }}>
      {children}
    </InactivityContext.Provider>
  );
}; 
